module.exports = __webpack_public_path__ + "img/mo.mo91c9cf0.svg";